import type { AxiosError, AxiosResponse } from 'axios'
import type { UseMutationOptions, UseQueryOptions } from 'react-query'
export const baseUrl = import.meta.env.VITE_BASE_URL

export * from './useEnums'
export * from './useVehicle'

export type QueryOptions = Omit<UseQueryOptions<AxiosResponse<any, any>, any, AxiosResponse<any, any>, any>, "queryKey" | "queryFn"> | undefined
export type GenericQueryOptions<T> = {
    enabled?: boolean
    onSuccess?: (data: AxiosResponse<T>) => void

    onError?: (error: AxiosError<any>) => void

    /** @deprecated you may want to use staleTime, cacheTime will be renamed to GcTime in react-query v5. */
    cacheTime?: number

    staleTime?: number

    retry?: UseQueryOptions['retry']
    refetchOnWindowFocus?: boolean
    refetchOnMount?: boolean

    refetchInterval?: number
}

export type MutationOptions = Omit<UseMutationOptions<AxiosResponse<any, any>, any, any, any>, "mutationKey" | "mutationFn"> | undefined
export type GenericMutationOptions<T> = Omit<UseMutationOptions<AxiosResponse<T, any>, any, any, any>, "mutationKey" | "mutationFn"> | undefined

export function appendToFormData(formData: FormData, data: any, parentKey?: string) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            // Pokud parentKey existuje, vytvoří klíč ve formátu 'parent[key]'. Jinak použije pouze 'key'.
            const fullKey = parentKey ? `${parentKey}[${key}]` : key
            appendToFormData(formData, data[key], fullKey)
        })
    } else {
        if (parentKey) {
            if (data === undefined)
                return

            // Pro primitivní typy nebo instance Date/File přidá hodnotu do FormData.
            if (data instanceof Date)
                formData.append(parentKey, data.toISOString())
            else
                formData.append(parentKey, data)
        }
    }
}

export * from './offerFilter'
export * from './useAccount'
export * from './useExport'
export * from './useInsuranceParamsFormPersistance'
export * from './useMeetingRecord'
export * from './useNavigateLogger'
export * from './useResetPassword'
export * from './useReturnUrlNavigate'
export * from './useSearchParamsStatePersistance'
export * from './useSso'
export * from './useTimeRange'

